module.exports = __webpack_public_path__ + "static/media/linked.d66dcce7.svg";